// Sin imports a propósito: lo usan api.js y los componentes.

const ETIQUETAS_CAMPO = {
  tracking: 'Tracking', transportista: 'Transportista', tienda: 'Tienda',
  orden_o_factura: 'Orden / factura', pais_origen: 'País de origen', bodega: 'Bodega',
  descripcion: 'Descripción del contenido', valor_declarado: 'Valor declarado',
  num_piezas: 'Piezas', tipo_empaque: 'Tipo de empaque', desea_consolidar: 'Consolidación',
  factura_adjunta: 'Factura', cedula: 'Cédula', whatsapp: 'WhatsApp',
  direccion_entrega_default: 'Dirección de entrega', email: 'Correo',
  nombre_completo: 'Nombre completo', first_name: 'Nombre', last_name: 'Apellido',
};

const CLAVES_SIN_ETIQUETA = new Set(['detail', 'error', 'non_field_errors', 'mensaje']);

function primerTexto(valor) {
  if (typeof valor === 'string') return valor;
  if (Array.isArray(valor)) {
    for (const v of valor) {
      const t = primerTexto(v);
      if (t) return t;
    }
    return null;
  }
  if (valor && typeof valor === 'object') {
    for (const [clave, v] of Object.entries(valor)) {
      const t = primerTexto(v);
      if (!t) continue;
      // "Este campo es obligatorio." solo no dice cuál campo: se le antepone.
      if (/^Este campo /i.test(t) && !CLAVES_SIN_ETIQUETA.has(clave)) {
        const etiqueta = ETIQUETAS_CAMPO[clave] || clave.replace(/_/g, ' ');
        return `${etiqueta}: ${t}`;
      }
      return t;
    }
  }
  return null;
}

/**
 * El mensaje que se le muestra al usuario cuando falla una petición.
 * Prioriza lo que dice el backend (validaciones); si la respuesta no es un
 * JSON legible (413 de nginx, 502/504, sin conexión) da una explicación útil
 * en vez de un genérico "no se pudo".
 */
export function mensajeErrorApi(err, fallback = 'No se pudo completar la acción.') {
  if (err && err.archivoIlegible) {
    return 'No pudimos leer el archivo que adjuntaste (el celular perdió el acceso a él). Vuelve a seleccionarlo, o tómale una foto, e inténtalo de nuevo.';
  }
  const res = err && err.response;
  if (!res) {
    return 'No pudimos conectar con el servidor. Revisa tu conexión a internet e inténtalo de nuevo.';
  }
  if (res.data && typeof res.data === 'object') {
    const texto = primerTexto(res.data);
    if (texto) return texto;
  }
  if (res.status === 413) {
    return 'El archivo que adjuntaste es demasiado pesado. Reduce su tamaño (por ejemplo, tómale una foto en lugar de un PDF) e inténtalo de nuevo.';
  }
  if (res.status >= 500) {
    return 'Tuvimos un problema de nuestro lado y ya quedó registrado. Inténtalo de nuevo en unos minutos o escríbenos por WhatsApp.';
  }
  return fallback;
}
